var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.40026,
    height: 36.2,
    viewBox: "0 0 54.40026 36.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-width:2px;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke:#b1cc33;stroke-width:2.1px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.4,24c-.52085-.03143-.96857,.36532-1,.88617-.00229,.03791-.00229,.07592,0,.11383,0,5.08102-4.11898,9.2-9.2,9.2-5.08102,0-9.2-4.11898-9.2-9.2,0-5.08102,4.11898-9.2,9.2-9.2h0l.2-2h-.2C5.01441,13.8,0,18.81441,0,25s5.01441,11.2,11.2,11.2,11.2-5.01441,11.2-11.2c.03143-.52085-.36532-.96857-.88617-1-.03791-.00229-.07592-.00229-.11383,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2,13.8c-1.32934,.02053-2.6465,.25694-3.9,.7l.9,1.8c.97034-.31174,1.981-.48019,3-.5,5.0808-.04771,9.23827,4.03242,9.28597,9.11322s-4.03242,9.23827-9.11322,9.28597c-4.91976,.04619-9.00515-3.78649-9.27276-8.69919l-2-.1c.2461,6.15554,5.43565,10.94609,11.59119,10.7,6.15554-.2461,10.94609-5.43565,10.7-11.59119-.23988-5.99998-5.18646-10.73336-11.19119-10.70881Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,17.2l-.9-1.8c-2.86344,1.70374-4.80941,4.60434-5.3,7.9l2,.1c.47797-2.56036,1.99954-4.80648,4.2-6.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.4,
    y1: 1,
    x2: 17.4,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.4,
    y1: 4.7,
    x2: 38.4,
    y2: 4.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.5,
    y1: 25,
    x2: 13.2,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.4,
    y1: 24,
    x2: 13.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.4,
    y1: 9,
    x2: 43.4,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.4,
    y1: 9,
    x2: 34.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.4,
    y1: 7.4,
    x2: 26.4,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.4,
    y1: 24,
    x2: 43.4,
    y2: 25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color-foreground"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.5,
    y1: 25,
    x2: 13.2,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.4,
    y1: 24,
    x2: 13.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.4,
    y1: 9,
    x2: 43.4,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.4,
    y1: 9,
    x2: 34.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.4,
    y1: 7.4,
    x2: 26.4,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.4,
    y1: 24,
    x2: 43.4,
    y2: 25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.46bd23af6a8175d9cc91cd7db7823cd1.svg";
export { ForwardRef as ReactComponent };